import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { ReactComponent as RepeatIcon } from '../../../images/arrow/repeat.svg';
import { ReactComponent as ShopBagIcon } from '../../../images/shoppingBag.svg';
import { ReactComponent as CoinsIcon } from '../../../images/coins.svg';
import { ReactComponent as QuestIcon } from '../../../images/circlequest.svg'
export const BagsBox = styled.div`
 
border-radius: 16px;
padding: 16px;
padding-bottom: 0;
min-width:fit-content;
width: 100%;
height: fit-content;
background: var(--colors-grey-50);
 @media (max-width: 1440px) {
    min-width: 872px;
  } 
@media (max-width: 1024px) {
    min-width: 616px;
  } 
  @media (max-width: 844px) {
    min-width: 342px;
  } 
`;


export const BagsTitleBox = styled.div`
  display: flex;
  flex-direction:column;
align-items: flex-start;
justify-content: space-between;
border-bottom: 1px solid var(--colors-grey-200);
padding: 0px 0px 12px 0px;
width:100%;


`;

export const BagsBodyBox = styled.div`
width: 100%;
height: fit-content;
max-height: 85vh;
padding: 16px 0 16px  0;
min-height: fit-content;
/* overflow-y: auto; */
`;


export const AllWrapBox = styled.div`
width: 100%;

display: flex;
gap: 16px;
flex-wrap: wrap;
@media (max-width: 1024px) {
  flex-direction:column;
  } 
  @media (max-width: 844px) {
  flex-direction:row;
  } 
  @media (max-width: 689px) {
  flex-direction:column;
  } 
`;
export const WrapBox = styled.div`
width:calc((100% - 16px) / 2);
border-radius: 16px;
padding: 16px;
background: var(--colors-grey-25);
display: flex;
align-items: center;
gap: 16px;
height: 79px;
@media (max-width: 1024px) {
    width: 100%;
  } 
  @media (max-width: 844px) {
   width:calc((100% - 16px) / 2);
  } 
    @media (max-width: 689px) {
   width:100%;
  } 
`;


export const TextBox = styled.div`
width: calc(100% - 68px);

display: flex;
flex-direction: column;
align-items: start;
gap: 4px;
`;

export const Title = styled.h3`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
`;

export const Text = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-500);
`;





export const BagsTitle = styled.h2`
display: flex;
align-items: center;
gap:8px;
font-family: var(--font-family);
font-weight: 600;
font-size: 20px;
line-height: 135%;
color: var(--colors-grey-800);
`;


export const BagsText = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-500);
`;



export const CustomLabel = styled.label`
border-radius: 40px;
background-color: var(--colors-grey-300);
width:52px; 
height:28px;
position: relative;
&::before{
  content:"";
  border-radius: 360px;
width: 24px;
height: 24px;
background: var(--colors-grey-25);
top:2px;
left:2px;
 transition: transform 0.3s ease;
  position: absolute;
}
`;
export const Checkbox = styled.input`
 opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  &:checked + label {
    background-color: var(--colors-primary-600);

    &::before {
      transform: translateX(24px);
    }
  }
`;

